export default __webpack_public_path__ + "static/media/touchOne.250ea7c8.svg";